import type { IHubCart } from "@models";

/** Default cart package id from GET /dxphub/carts/user/{userId} (single cart payload). */
export function defaultHubCartPackageId(cart: IHubCart | undefined): number {
  if (cart?.packageId != null && cart.packageId > 0) return cart.packageId;
  return 0;
}
